import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { WebinarLinkIcon, RightArrowIcon } from 'secondstep-components'
import { themeGet } from 'styled-system'

export const IconRightArrow = styled(RightArrowIcon).attrs(props => ({
  fill: themeGet('colors.themePrimary')(props),
}))`
  display: none;
  width: 15px !important;
  height: 15px !important;
  margin: 1px 0 0 0 !important;
`
export const StyledLink = styled(Link)`
  display: flex;
  text-decoration: none;
  color: ${themeGet('colors.themeAccent')};
  font-weight: 400;
  font-family: ${themeGet('font.molde.medium')};
`

export const IconWebinar = styled(WebinarLinkIcon).attrs(props => ({
  fill: themeGet('colors.themeAccent')(props),
  height: '0.9375rem',
  width: '0.9375rem',
  variant: 'sm',
}))`
  margin-left: 1px;
  margin-right: 10px;
`

export const Row = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  &:hover {
    ${IconRightArrow} {
      display: inline;
      ${themeGet('breakpoints.mobile')} {
        display: none;
      }
    }

    ${StyledLink} {
      color: ${props => themeGet('colors.themePrimary')(props)};
    }
    #webinar-icon {
      fill: ${props => themeGet('colors.themePrimary')(props)};
    }
  }
`

export const WebinarLinkAndIcon = styled.span`
  align-items: center;
  display: flex;
`
